import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "finder-container"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "optional-role-name"
};
const _hoisted_4 = {
  style: {
    "font-weight": "normal",
    "font-size": "0.7rem"
  }
};
import { ref, computed } from 'vue';
import { ElButton, ElImage, ElInput, ElMessage, ElRow } from 'element-plus';
import { request } from '@/manager/net_manager';
import store from '@/store';
export default {
  __name: 'RoleFinder',
  props: {
    closeOnClick: {
      type: Boolean,
      default: false,
      required: false
    },
    optionNumber: {
      type: Number,
      default: 3,
      required: false
    }
  },
  emits: ['selected-role'],

  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emits = __emit;
    const props = __props; // refs

    const message = ref(null);
    const searchRole = ref('');
    const optionalRoles = ref([]);
    const selectedRole = ref(null); // computed

    const worldOutlook = computed(() => store.state.world_outlook); // functions

    const findRole = () => {
      if (message.value) {
        message.value.close();
      }

      if (!worldOutlook.value) {
        message.value = ElMessage.error({
          message: '未选择世界观',
          duration: 1500
        });
        return;
      }

      if (!searchRole.value || searchRole.value.length === 0) {
        // message.value = ElMessage.error({message: '无检索信息', duration: 1500})
        optionalRoles.value = [];
        selectedRole.value = null;
        return;
      }

      let parameters = {
        'world_outlook_id': worldOutlook.value.id,
        'search': searchRole.value,
        'numbers': props.optionNumber
      };
      request('role/find_role/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        optionalRoles.value = response.data;
      });
    };

    const roleClick = item => {
      if (props.closeOnClick) {
        if (selectedRole.value === item) {
          selectedRole.value = null;
          emits('selected-role', item, false);
        } else {
          selectedRole.value = item;
          emits('selected-role', item, true);
        }
      } else {
        if (selectedRole.value !== item) {
          selectedRole.value = item;
          emits('selected-role', item);
        }
      }
    };

    const clearFinder = () => {
      searchRole.value = '';
      optionalRoles.value = [];
      selectedRole.value = null;
    }; // post-declaration


    __expose({
      clearFinder
    });

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElRow), {
        style: {
          "align-items": "center"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElInput), {
          modelValue: searchRole.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchRole.value = $event),
          maxlength: "16",
          clearable: "",
          "show-word-limit": "",
          placeholder: "搜索角色"
        }, null, 8, ["modelValue"]), _createVNode(_unref(ElButton), {
          class: "find-role",
          onClick: findRole
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" 查找用户 ", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        style: {
          "margin-top": "1.0rem"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionalRoles.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.id,
            class: _normalizeClass(["optional-roles-card", selectedRole.value && item.id === selectedRole.value.id ? 'selected-roles-card' : '']),
            onClick: $event => roleClick(item)
          }, [_createVNode(_unref(ElImage), {
            src: item.avatar,
            fit: "cover",
            draggable: "false"
          }, null, 8, ["src"]), _createElementVNode("text", _hoisted_3, [_createTextVNode(_toDisplayString(item.nickname) + " ", 1), _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)), _createElementVNode("span", _hoisted_4, " id: " + _toDisplayString(item.id), 1)])], 10, _hoisted_2);
        }), 128))]),
        _: 1
      })]);
    };
  }

};